import { AppThunk } from "@Store/index";
import { fetchBookingDetailsIfNeeded } from "./bookingDetailsReducer";

const loadData = (props: any): AppThunk[] => [fetchBookingDetailsIfNeeded(props)];

export default loadData;
